module.exports = __webpack_public_path__ + "static/media/2.828ad98c.jpg";